import { createContext } from 'react'

const DaiChatContext = createContext()

export default DaiChatContext
